import React from "react";

import Select from "antd/es/select";
import { useIntl } from "react-intl";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";

interface Props {
  onChange: (sorting: SortOrder) => void;
  sorting: SortOrder;
}

const ConfigSortOrderSelect: React.FC<Props> = ({ onChange, sorting }) => {
  const intl = useIntl();

  return (
    <Select<SortOrder>
      onChange={onChange}
      options={[
        {
          label: intl.formatMessage({
            id: "settings.newImports.config.configListPanel.sortOrder.mostRecent",
            defaultMessage: "Most Recent",
            description: "Imports config list pane list order option - most recent",
          }),
          value: SortOrder.DESC,
        },
        {
          label: intl.formatMessage({
            id: "settings.newImports.config.configListPanel.sortOrder.leastRecent",
            defaultMessage: "Least Recent",
            description: "Imports config list pane list order option - least recent",
          }),
          value: SortOrder.ASC,
        },
      ]}
      value={sorting}
    />
  );
};

export default ConfigSortOrderSelect;
